import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './BannerFaq/Faq.module.scss';
import styles2 from '../../styles/Accordion.module.scss';
import styles3 from './EcsPortal.module.scss';
import styles4 from './BannerModal/BannerModal.module.scss';
import CategoriesPopup from './CategoriesPopup';
import { useAuth } from '../../contexts/auth';
import {
  CheckingValidComment,
  jdrrBannerCategoryObj,
  mobileBannerCategoryObj,
  jdrrBannerCategoryObjGenio,
} from '../../lib/common';
import { bannerTickerCreate, uploadFiles } from '../../api';
import { useSessionStorage } from '../../hooks';

function BannerCategory({ data, searchQuestion, setAlert, showTicketCreation, bannerData, faqId, projectId }) {
  const getBannerType = sessionStorage.getItem('bannerType');
  const [showMore, setShowMore] = useState(false);
  const [showTicketCreate, setShowTicketCreate] = useState(false);
  const [issueComment, setIssueComment] = useState('');
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bannerTicketCreationResp, setBannerTicketCreationResp] = useState('');
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const [userDetails] = useSessionStorage('userDetails', '');

  const enableSubmitButton = (CheckingValidComment(issueComment) || fileData?.length > 0) && !loading;
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [haveSubmitted, setHaveSubmitted] = useState(false);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const files = event.target.files ? [...event.target.files] : [];
      const tempFileData = [];
      try {
        setLoading(true);
        const response = await uploadFiles(files, true);
        if (response.error_code === 0) {
          setLoading(false);
          if (response.image_urls && response.image_urls.length > 0) {
            tempFileData.push({ name: files[0].name, url: response.image_urls[0] });
            setFileData(tempFileData);
          }
        }
      } catch (err) {
        console.log('Error: ', err);
      }
    } else {
      setAlert({
        message: 'Accepts only image file',
        status: false,
      });
    }
  };

  const handleSubmit = async () => {
    setHaveSubmitted(true);
    try {
      const commonParams = {
        id: 'webBannerTicketCreate',
        issueComment: issueComment || '',
        correctionImageUrl: fileData?.[0] ? fileData?.[0]?.url : '',
        sourceNm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
        src: projectId === 'csportal' ? 'business' : 'sales-genio',
        srcType: projectId === 'csportal' ? 'csportal' : 'internal',
        projectId: projectId === 'csportal' ? 1 : '',
      };
      let updtParams = {};
      if (projectId === 'csportal') {
        updtParams = {
          ...commonParams,
          dataCity: selectedBusiness?.data_city || '',
          docid: selectedBusiness?.docid || '',
          parentid: selectedBusiness?.parentid || '',
          companyname: selectedBusiness?.compname || '',
          fullName: selectedBusiness?.fullName || '',
          mobile: selectedBusiness?.mobile || '',
          createdBy: userDetails?.mobile || '',
        };
      } else {
        updtParams = {
          ...commonParams,
          dataCity: selectedBusinessGenio?.city ? encodeURIComponent(selectedBusinessGenio?.city) : '',
          docid: selectedBusinessGenio?.docId || '',
          parentid: selectedBusinessGenio?.parentId || '',
          companyname: selectedBusinessGenio?.companyName ? encodeURIComponent(selectedBusinessGenio?.companyName) : '',
          fullName: profile?.full_name || '',
          mobile: selectedBusinessGenio?.mobile || '',
          createdBy: profile?.mobile || '',
        };
      }

      const mobileBannerParams = {
        id: 'mobileBannerTicketCreate',
        banner_path: fileData?.[0] ? fileData?.[0]?.url : '',
        instruction: issueComment || '',
      };

      if (getBannerType === 'Mobile Banner') {
        updtParams = {
          ...updtParams,
          ...mobileBannerParams,
        };
      }

      const document = [];
      if (fileData?.length > 0) {
        fileData?.forEach((item) => {
          document.push({
            nm: item.name,
            url: item.url,
          });
        });
      }
      updtParams.document = document || [];
      const res = await bannerTickerCreate(updtParams);
      setBannerTicketCreationResp(
        res?.errorCode === 0 ? res?.result || '' : res?.result || res?.message || 'Something Went Wrong!',
      );
    } catch (e) {
      console.log('Error in jdrr ticket creation', e);
    }
    setIssueComment('');
    setFileData([]);
    setShowTicketCreate(false);
    setHaveSubmitted(false);
  };
  const categoryObj =
    getBannerType === 'Mobile Banner'
      ? mobileBannerCategoryObj
      : projectId === 'csportal' && faqId === 4
        ? jdrrBannerCategoryObj
        : jdrrBannerCategoryObjGenio;
  return (
    <>
      {faqId !== 16 && (
        <>
          <ul className={`${styles.ListGroup}`}>
            {data &&
              Object.keys(data).length > 0 &&
              categoryObj &&
              Object.keys(categoryObj).map((each, idx) => (
                <li className={`${styles.ListItem}`} key={idx}>
                  <label htmlFor={idx} className={`${styles.ListLabel} font13 fw400 color111`}>
                    {categoryObj?.[each] || ''}
                  </label>
                  <div className={`${styles.ListText} font13 fw500 color111`}>
                    :
                    <span
                      className={`capitalize font12 fw500 ml-4 ${
                        each === 'status' && data?.[each] === 'inactive'
                          ? 'colorEC4'
                          : ['Active', 'LIVE'].includes(data?.[each])
                            ? 'color339'
                            : 'color1A1'
                      }`}
                    >
                      {each === 'status' && data?.[each] === 'inactive' ? 'InActive' : data?.[each] || '--'}
                    </span>
                  </div>
                </li>
              ))}
          </ul>

          {((getBannerType === 'Mobile Banner' && bannerData?.mobileBannerImg) ||
            (getBannerType === 'Web Banner' && bannerData?.bannerImg)) && (
            <>
              <div className={`${styles.CategoryBannerBox} mt-20`}>
                {projectId === 'csportal' && faqId === 2 ? (
                  <>
                    <div className="font12 fw600 color111">Note</div>
                    <div className="font12 mt-10">
                      If you&apos;re unable to locate your banner on the website, please refer to the following
                      categories listed in your listing. Search any of these keywords in the JD App, and your banner
                      will appear randomly along with the others.
                    </div>
                  </>
                ) : (
                  <>
                    <div className="font12 fw600 color111">Category sponsorship banner</div>
                    <div className={`${styles.CategoryBanner} mt-10`}>
                      <img
                        className={`${styles.CategoryBannerImage}`}
                        src={getBannerType === 'Mobile Banner' ? bannerData?.mobileBannerImg : bannerData?.bannerImg}
                        alt="Category sponsorship banner"
                      />
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}

      {data?.categories && data?.categories?.length > 0 && (
        <>
          <div className={`${styles.CategoryListGroup} ${faqId !== 16 ? 'mt-20' : 'mt-10'}`}>
            {faqId === 16 && (
              <>
                <div className="font12 fw500 color111">Here&apos;s the list of categories signed in your listing.</div>
                <div className="font12 fw500 color111">
                  Search any of these keywords in the JD App, your banner will appear randomly along with the other
                  banners.
                </div>
              </>
            )}
            <div className="font12 fw600 color111">Categories</div>
            {data?.categories.slice(0, 5).map((item, i) => (
              <div key={i} className={`${styles.CategoryListItem} font12 fw400 color111 mt-5 mb-5`}>
                {`${i + 1}. ${item || ''}`}
              </div>
            ))}
          </div>
          {data?.categories && data?.categories?.length > 5 && (
            <div className="ml-2 mt-5">
              <button
                type="button"
                className={`${styles2.viewMore_Btn_jdrr}`}
                onClick={() => {
                  setShowMore((prev) => !prev);
                }}
              >
                {searchQuestion === '' && 'view more'}
              </button>
            </div>
          )}
        </>
      )}
      {showTicketCreation && !bannerTicketCreationResp && (
        <>
          <div className="font12 fw400 color111 mt-20">
            Need correction in design?
            <button
              id="ButtonNoBackground"
              type="button"
              onClick={() => {
                setShowTicketCreate(true);
              }}
              className="anchor font13 fw600 color007"
            >
              CLICK HERE
            </button>
          </div>
        </>
      )}

      {showTicketCreate && !bannerTicketCreationResp && (
        <div className="csexpndwp active">
          <div className="csexpndwp_content">
            <div className="mb-10">
              <span className="font12">Description</span>
              <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
            </div>
            <textarea
              className={`${styles3.Accordion__TextArea}`}
              value={issueComment}
              placeholder="Please describe your issue here, our team will get back to you within 24-48 hours"
              onChange={(e) => {
                setIssueComment(e.target.value);
              }}
            />

            <label htmlFor="coverImage" className={`${styles4.BannerModal__Attachment}`}>
              <input
                id="coverImage"
                type="file"
                hidden
                accept="image/*"
                onChange={handleFileUpload}
                onClick={(e) => {
                  e.target.value = null;
                }}
                name=""
              />
              <span className={`${styles4.BannerModal__AttachText} font13 fw500 color007 mr-10`}>
                Upload cover image (optional)
              </span>
              <span className={`${styles4.AttachmentIcon} cs_icon`} />
            </label>

            {loading ? (
              <div className="mt-10">
                <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
              </div>
            ) : (
              fileData &&
              fileData?.length > 0 &&
              fileData?.[0] && <div className="font11 fw500 color777 mb-15 ml-4 mt-6">{fileData?.[0]?.name || ''}</div>
            )}

            <button
              type="button"
              className={`${styles2.Accordion__Contant__Button} font14 fw600 colorFFF mt-10`}
              style={{
                backgroundColor: `${enableSubmitButton ? '#0076d7' : ''}`,
                border: `1px solid ${!enableSubmitButton ? '#E0E0E0' : '#0076d7'}`,
                transitionProperty: 'background-color, background-image, border-color, box-shadow',
                transition: 'all 0.8s',
                color: `${!enableSubmitButton ? 'rgb(197 167 167)' : '#fff'}`,
              }}
              disabled={!enableSubmitButton || haveSubmitted}
              onClick={() => handleSubmit()}
            >
              Submit
            </button>
            {issueComment && issueComment?.length > 3 && !CheckingValidComment(issueComment) && (
              <span className="font12 colorEC4">Please avoid special characters.</span>
            )}
          </div>
        </div>
      )}

      {bannerTicketCreationResp && <div className="font12 fw600 color111 mt-10">{bannerTicketCreationResp}</div>}

      {showMore && (
        <CategoriesPopup
          categories={data?.categories || []}
          setShowMore={setShowMore}
          showAddDeleteKeywordsBtn={faqId === 16}
          projectId={projectId}
        />
      )}
    </>
  );
}
export default BannerCategory;

BannerCategory.propTypes = {
  data: PropTypes.object,
  searchQuestion: PropTypes.string,
  setAlert: PropTypes.func,
  showTicketCreation: PropTypes.bool,
  bannerData: PropTypes.object,
  faqId: PropTypes.number,
  projectId: PropTypes.string,
};
